import { createAction } from 'redux-actions';

import {
	GET_MAKE_UP_PUNCH_RULE_SETTING_CALL,
	GET_MAKE_UP_PUNCH_RULE_SETTING_DONE,
	GET_MAKE_UP_PUNCH_RULE_SETTING_FAIL,
} from '@src/store/types';

export const getMakeUpPunchRuleSettingCall = createAction(GET_MAKE_UP_PUNCH_RULE_SETTING_CALL);
export const getMakeUpPunchRuleSettingDone = createAction(GET_MAKE_UP_PUNCH_RULE_SETTING_DONE);
export const getMakeUpPunchRuleSettingFail = createAction(GET_MAKE_UP_PUNCH_RULE_SETTING_FAIL);
